const escapeHtml = text =>
  text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

// Formatação do WhatsApp (*negrito*, _itálico_, ~tachado~, ```mono```) e
// quebras de linha, como a Meta renderiza o corpo do template no aparelho.
export const formatWhatsAppText = text => {
  if (!text) return '';
  let html = escapeHtml(text);
  html = html.replace(/```([\s\S]+?)```/g, '<code>$1</code>');
  html = html.replace(
    /(^|[\s(])\*([^*\n]+)\*(?=$|[\s.,!?;:)])/gm,
    '$1<b>$2</b>'
  );
  html = html.replace(/(^|[\s(])_([^_\n]+)_(?=$|[\s.,!?;:)])/gm, '$1<i>$2</i>');
  html = html.replace(/(^|[\s(])~([^~\n]+)~(?=$|[\s.,!?;:)])/gm, '$1<s>$2</s>');
  return html.replace(/\n/g, '<br />');
};
